import {
  collection,
  doc,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { TableName } from "../constants/tableName";

export class FeaturesController {
  static TABLE_NAME = TableName.FEATURES;

  static getAll = ({ resolve, reject }) => {
    let errorMessage =
      "Unable to get all the features details.\nPlease contact administrator for assistance.";
    getDocs(collection(db, this.TABLE_NAME))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static add = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to create new features details.\nPlease contact administrator for assistance.";
    addDoc(collection(db, this.TABLE_NAME), parameters)
      .then(() => {
        resolve("New features details added to firebase successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static update = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to update the selected features details.\nPlease contact administrator for assistance.";
    updateDoc(doc(db, this.TABLE_NAME, parameters.id), parameters)
      .then(() => {
        resolve("features details updated to firebase successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static deleteAll = ({ idList, resolve, reject }) => {
    let errorMessage =
      "Unable to delete all the features details.\nPlease contact administrator for assistance.";
    const deletePromises = idList.map((id) => {
      return deleteDoc(doc(db, this.TABLE_NAME, id)).catch((error) => {
        console.debug(error.message);
        throw error;
      });
    });
    Promise.all(deletePromises)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case "permission-denied":
        errorMessage = "You are not authorised for this action.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
